export enum UsernameType {
    SMS = "SMS",
    EMAIL = "EMAIL"
}